import { Badge } from '@/components/ui/badge';

export default function InjectionManifestChips({ manifest, compact = false }) {
  const blocks = manifest?.blocks || [];
  if (!blocks.length) {
    return <span className="text-[10px] text-zinc-400">Sin manifiesto de inyeccion</span>;
  }

  return (
    <div className={`flex flex-wrap gap-1 ${compact ? '' : 'mt-2'}`}>
      {blocks.map((b, i) => {
        const injected = b.injected;
        const isRef = b.role === 'reference';
        const cls = injected
          ? (isRef ? 'bg-blue-50 text-blue-800 border-blue-200' : 'bg-emerald-50 text-emerald-800 border-emerald-200')
          : 'bg-zinc-100 text-zinc-400 border-zinc-200';
        return (
          <Badge key={`${b.source}-${i}`} variant="outline" className={`text-[9px] rounded-sm ${cls}`} title={b.preview || b.label}>
            {b.label || b.source}
            {injected ? ` (${b.chars || 0}c)` : ' (vacio)'}
          </Badge>
        );
      })}
    </div>
  );
}
